import { makeStyles } from '@material-ui/core/styles';

const mainLayoutStyle = makeStyles(() => ({
  content: {
    // maxWidth: '1030px',
    // minWidth: '1030px',
    margin: '0 auto',
    boxSizing: 'border-box',
    padding: '0 10px',
    minHeight: '360px',
  },
}));

export default mainLayoutStyle;
